import { Stack } from "@chakra-ui/react";
import React, { memo } from "react";
import { StickyNavContainer } from "../style";
import MainNavigation from "./MainNavigation";
import MobileHeader from "./MobileHeader";

import SubNavigation from "./SubNavigation";

interface Props {}

const Header: React.FC<Props> = () => {
  return (
    <StickyNavContainer>
      <Stack
        spacing={0}
        sx={{
          "@media (max-width: 1023px)": {
            display: "none",
          },
        }}
      >
        <SubNavigation />
        <MainNavigation />
      </Stack>
      <Stack
        h={"6.25rem"}
        sx={{
          "@media (min-width: 1024px)": {
            display: "none",
          },
        }}
      >
        <MobileHeader />
      </Stack>
    </StickyNavContainer>
  );
};

export default memo(Header);
